import axios from 'axios';
import { RECHTE_STAND_HEADER, rechteStand } from './rechteStand';

// Eindeutige ID pro Browser-Tab/Session. Dient der Selbst-Echo-Unterdrückung im
// WebSocket-Handler PRO TAB statt pro Benutzer (#269): So synchronisiert derselbe
// Account in zwei Browsern/Geräten live, während ein Tab weiterhin nur sein eigenes
// Echo ignoriert.
export const CLIENT_ID: string =
  (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
    ? crypto.randomUUID()
    : `c-${Math.random().toString(36).slice(2)}-${Date.now()}`;

const api = axios.create({ baseURL: '/api', headers: { 'X-Client-Id': CLIENT_ID } });

// Auch für weitere axios-Instanzen als Default setzen (best effort).
axios.defaults.headers.common['X-Client-Id'] = CLIENT_ID;

// Rollen & Rechte, Etappe 4: Ändert sich der Rechte-Stand des Servers, lädt die App das eigene Konto nach (Erfolg und Fehlerantworten)
api.interceptors.response.use(
  response => { rechteStand.meldeStand(response?.headers?.[RECHTE_STAND_HEADER]); return response; },
  error => { rechteStand.meldeStand(error?.response?.headers?.[RECHTE_STAND_HEADER]); return Promise.reject(error); },
);

export const setAuthToken = (token: string | null) => {
  rechteStand.zuruecksetzen(); // neue Sitzung (oder Abmeldung): der nächste Stand ist wieder ein erster
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};

export default api;
